export default "__VITE_ASSET__Z7VJ5xgM__"